import { render, staticRenderFns } from "./PublicLayout.vue?vue&type=template&id=4a3fb788&scoped=true&"
import script from "./PublicLayout.vue?vue&type=script&lang=js&"
export * from "./PublicLayout.vue?vue&type=script&lang=js&"
import style0 from "./PublicLayout.scss?vue&type=style&index=0&id=4a3fb788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3fb788",
  null
  
)

export default component.exports